import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-request-take-action',
  templateUrl: './request-take-action.component.html',
  styleUrls: ['./request-take-action.component.css']
})
export class RequestTakeActionComponent implements OnInit {
  
  @Input() popup  = true;
  @Input() modalTitle  = 'Take Action';
  @Input() isEdit:boolean = false;
  @Input() requestID;
  @Input() requestData;
  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();

  
  public actionForm:FormGroup;
  public formSubmitted:boolean = false;
  public fieldOptions = {
    reqStatus:[
      {name:'Completed',value:'3'},
      {name:'In-Progress',value:'2'},
      // {name:'Pending',value:1},
      {name:'Rejected',value:'4'}, ],
    };
  
  constructor(
    private fb:FormBuilder,
    public swal: SweetAlert,
    public api: ApiService) { 

    }

  ngOnInit(): void {
    this.actionFormLoad();
    if(this.isEdit) this.patchActionForm();
  }

  actionFormLoad(){
    this.actionForm = new FormGroup({
      reqStatus: new FormControl('', [Validators.required]),
      actionMessage: new FormControl('', [Validators.required]),
    });
  }
  patchActionForm(){
    this.actionForm.patchValue({
      reqStatus:this.requestData.reqStatus?this.requestData.reqStatus:'',
      actionMessage:this.requestData.actionMessage?this.requestData.actionMessage:'',
    })
  }
  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.actionForm.controls[controlName].hasError(errorName);
  }

  onSubmit(){
    this.formSubmitted = true;
    if(this.actionForm.valid){
      let obj = {
        requestID:this.requestData.requestID,
        requestData:this.requestData.data,
        // user:this.requestData,
        ...this.actionForm.value,
      }
      obj['reqStatus']= +obj['reqStatus']
      this.result.emit(obj);
      this.closePopup();
    }
    console.log(this.actionForm,this.actionForm.invalid);
  }
  closePopup(){
    this.closeEvent.emit(true);
  }
}
